<template lang="html">
  <v-card class="ma-0  d-flex flex-column" elevation="4" :color="color" height="100%">
    <v-card-title class="text-h6 pb-2">
      {{ title }}
    </v-card-title>
    <v-card-subtitle class="pb-0">
      {{ subtitle }}
    </v-card-subtitle>
    <v-card-text class="px-1 pb-0">
      <slot></slot>
    </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions  v-if="more" class="pt-0">
      <v-spacer></v-spacer>
      <v-btn
        plain
        x-small
        :to="more"
      >
        more
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: [
    'title', 'subtitle', 'more', 'color'
  ]
}
</script>

<style lang="css">
  .factor {
    font-size: 1.50em !important;
    font-weight: bold;
    color: green;
    text-shadow: 0px 0px 5px green;

  }
</style>
